import HeraTopographicMapElement from './components/HeraTopographicMapElement.vue';
import HeraMaintenancePhotoElement from './components/HeraMaintenancePhotoElement.vue';

export const vueformExtensionElements = [HeraTopographicMapElement, HeraMaintenancePhotoElement];